// Kalendář úkolů (191) — čisté výpočty bez Reactu. Kalendář je jen jiný pohled na
// stejné úkoly jako Kanban a Seznam: termín (deadline) = konec, start_date = začátek
// vícedenní práce, time_from/time_to = nepovinný čas. Nepřítomnosti se jen ČTOU z Docházky.
export const GRID_START = 7;
export const GRID_END = 19;

export const TASK_TYPES = ["task", "call", "meeting", "email"];
export const TYPE_LABEL = { task: "Úkol", call: "Hovor", meeting: "Schůzka", email: "E-mail" };

export const ROLE_ORDER = ["OWNER", "MANAGER", "ASSISTANT", "ACCOUNTANT", "DESIGNER", "WAREHOUSE", "WORKER", "SUBCONTRACTOR"];
export const ROLE_LABEL = { OWNER: "Majitel", MANAGER: "Stavbyvedoucí", ASSISTANT: "Asistentka", ACCOUNTANT: "Účetní",
  DESIGNER: "Projektant", WAREHOUSE: "Skladník", WORKER: "Dělník", SUBCONTRACTOR: "Subdodavatel" };
export const LEAD_ROLES = ["OWNER", "MANAGER", "ASSISTANT"];
// Pracovní doba podle role — šedé „mimo pracovní dobu“ a hledání volna.
export const WORK = { OWNER: [8, 17], MANAGER: [7, 16], ASSISTANT: [8, 16.5], ACCOUNTANT: [8, 16.5], DESIGNER: [8, 16.5],
  WAREHOUSE: [7, 15.5], WORKER: [7, 15.5], SUBCONTRACTOR: [7, 15] };
export const workOf = (p) => WORK[p?.role] || [7, 16];
// Komu se hlídá „na zítra nemá nic“ — lidé, kteří ráno potřebují vědět, co dělat.
export const PLANNED_ROLES = ["MANAGER", "ASSISTANT", "WAREHOUSE", "WORKER", "SUBCONTRACTOR"];

// Nepřítomnost z Docházky (routes/absences.py TYPES).
export const ABSENCE = {
  dovolena: { label: "Dovolená", tone: "leave" },
  nemoc: { label: "Nemoc", tone: "sick" },
  lekar: { label: "Lékař", tone: "sick" },
  nahradni_volno: { label: "Náhradní volno", tone: "off" },
  neplacene_volno: { label: "Neplacené volno", tone: "off" },
};
export const TONE = {
  leave: { tag: "bg-amber-500/15 text-amber-800 dark:text-amber-200", fg: "#8a6a2c",
    hatch: "repeating-linear-gradient(135deg, rgba(201,163,90,.28) 0 6px, rgba(201,163,90,.08) 6px 12px)" },
  sick: { tag: "bg-red-500/15 text-red-700 dark:text-red-300", fg: "#b02f22",
    hatch: "repeating-linear-gradient(135deg, rgba(217,58,43,.22) 0 6px, rgba(217,58,43,.06) 6px 12px)" },
  off: { tag: "bg-slate-500/15 text-slate-700 dark:text-slate-300", fg: "#4f5260",
    hatch: "repeating-linear-gradient(135deg, rgba(100,110,130,.22) 0 6px, rgba(100,110,130,.06) 6px 12px)" },
};
export const OFF_HOURS_BG = "repeating-linear-gradient(135deg, rgba(127,127,127,.09) 0 5px, transparent 5px 10px)";

// Stavy úkolu v kalendáři: Otevřené · Vráceno · Ke schválení · Po termínu · Schváleno.
export const STATUS = {
  open: { label: "Otevřené", pill: "bg-blue-500/15 text-blue-700 dark:text-blue-300", block: "bg-blue-500/10 text-blue-800 dark:text-blue-200 border-blue-500/30", dot: "bg-blue-500" },
  returned: { label: "Vráceno", pill: "bg-orange-500/15 text-orange-700 dark:text-orange-300", block: "bg-orange-500/10 text-orange-800 dark:text-orange-200 border-orange-500/35", dot: "bg-orange-500" },
  review: { label: "Ke schválení", pill: "bg-violet-500/15 text-violet-700 dark:text-violet-300", block: "bg-violet-500/10 text-violet-800 dark:text-violet-200 border-violet-500/30", dot: "bg-violet-500" },
  overdue: { label: "Po termínu", pill: "bg-destructive/15 text-destructive", block: "bg-destructive/10 text-destructive border-destructive/30", dot: "bg-destructive" },
  done: { label: "Schváleno", pill: "bg-success/15 text-success", block: "bg-success/10 text-success border-success/30", dot: "bg-success" },
};
export const STATUS_ORDER = ["open", "returned", "review", "overdue", "done"];

export const DOW = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];
export const DOW_LONG = ["pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota", "neděle"];
export const MONTHS = ["Leden", "Únor", "Březen", "Duben", "Květen", "Červen", "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec"];
export const MONTHS_GEN = ["ledna", "února", "března", "dubna", "května", "června", "července", "srpna", "září", "října", "listopadu", "prosince"];

const PALETTE = ["#e0703f", "#2c6ecb", "#17876a", "#9b5fc0", "#a87a22", "#5f6b7a", "#c2415d", "#0f8a9a", "#7a5cc4", "#3f7d3a"];
export const personColor = (id = "") => PALETTE[[...String(id)].reduce((s, c) => (s * 31 + c.charCodeAt(0)) >>> 0, 7) % PALETTE.length];
export const initials = (name) => ((name || "").split(" ").filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase()) || "?";
export const norm = (s) => (s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();

export const pad = (n) => String(n).padStart(2, "0");
export const ymd = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const parseLocal = (s) => { const [a, b = "00:00"] = String(s).split("T"); const [y, m, d] = a.split("-").map(Number); const [hh, mm] = b.split(":").map(Number); return new Date(y, m - 1, d, hh || 0, mm || 0); };
export const day0 = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate());
export const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n, d.getHours(), d.getMinutes());
export const dow = (d) => (d.getDay() + 6) % 7;
export const mondayOf = (d) => addDays(day0(d), -dow(d));
export const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
export const hm = (d) => `${d.getHours()}:${pad(d.getMinutes())}`;
export const hourOf = (d) => d.getHours() + d.getMinutes() / 60;
export const fmtH = (x) => `${Math.floor(x)}:${pad(Math.round((x % 1) * 60))}`;
export const hhmm = (x) => `${pad(Math.floor(x))}:${pad(Math.round((x % 1) * 60))}`;
export const toH = (t) => { const [a, b] = String(t).split(":").map(Number); return a + (b || 0) / 60; };
export const atHour = (day, h) => new Date(day.getFullYear(), day.getMonth(), day.getDate(), Math.floor(h), Math.round((h % 1) * 60));
export const dayLabel = (d) => `${DOW[dow(d)]} ${d.getDate()}. ${d.getMonth() + 1}.`;
export const daysWord = (n) => (n === 1 ? "den" : n >= 2 && n <= 4 ? "dny" : "dní");
export const peopleWord = (n) => (n === 1 ? "člověk" : n >= 2 && n <= 4 ? "lidé" : "lidí");
export const tasksWord = (n) => (n === 1 ? "úkol" : n >= 2 && n <= 4 ? "úkoly" : "úkolů");
// Příští pracovní den (v pátek = pondělí) — „na zítra nemá nic“.
export const nextWorkday = (d) => { let x = addDays(day0(d), 1); while (dow(x) > 4) x = addDays(x, 1); return x; };

// Úkol → položka kalendáře (_s, _e). Úkol bez termínu v kalendáři není.
export function taskItem(t) {
  const dl = (t.deadline || "").slice(0, 10);
  if (!dl) return null;
  const sd = (t.start_date || "").slice(0, 10) || dl;
  const timed = !!t.time_from;
  let _s, _e;
  if (timed) {
    _s = parseLocal(`${sd}T${t.time_from}`);
    _e = parseLocal(`${dl}T${t.time_to || hhmm(Math.min(toH(t.time_from) + 1, 23.75))}`);
    if (_e <= _s) _e = new Date(_s.getTime() + 30 * 60000);
  } else {
    _s = parseLocal(`${sd}T00:00`);
    _e = addDays(parseLocal(`${dl}T00:00`), 1);
  }
  // Do mřížky po hodinách patří jen jednodenní úkol s časem; ostatní jsou „během dne“.
  return { ...t, type: t.type || "task", assignees: t.assignees || [], _s, _e, timed, inGrid: timed && sd === dl };
}

export function taskStatus(t, today = new Date()) {
  if (t.status === "Schváleno") return "done";
  if (t.status === "Hotovo") return "review";
  const dl = (t.deadline || "").slice(0, 10);
  if (dl && dl < ymd(day0(today))) return "overdue";
  if (t.returned) return "returned";
  return "open";
}
export const isOpenTask = (t) => t.status === "Nový" || t.status === "V řešení";
export const spansDay = (a, d) => a._s < addDays(day0(d), 1) && a._e > day0(d);
// Pořadí v jednom dni: nejdřív „během dne“, pak podle začátku.
export const byStart = (x, y) => (x.inGrid === y.inGrid ? x._s - y._s : x.inGrid ? 1 : -1);

// Úkoly po dnech pro celé zobrazené okno (218) — jednou, místo filtru všech úkolů pro
// každou buňku kalendáře. Pro každý den okna vrací totéž co
// items.filter((a) => spansDay(a, den)).sort(byStart); klíč je ymd(den).
export function indexByDay(items, from, n) {
  const start = day0(from);
  const end = addDays(start, n);
  const map = new Map();
  for (const a of items) {
    if (!(a._s < end && a._e > start)) continue;
    for (let d = a._s > start ? day0(a._s) : start; d < end && d < a._e; d = addDays(d, 1)) {
      const k = ymd(d);
      const list = map.get(k);
      if (list) list.push(a); else map.set(k, [a]);
    }
  }
  map.forEach((list) => list.sort(byStart));
  return map;
}

// Okno úkolů pro kontrolu kolizí v dialogu Nový úkol (218): týden vybraného dne a další
// 4 týdny (hledání volna 21 dní), vícedenní úkol až do konce, u data v minulosti ještě
// 3 týdny od dneška (volno se hledá od teď). `end` je výlučný konec (jako _e).
export function workloadWindow(start, end, now = new Date()) {
  const from = mondayOf(start);
  let to = addDays(from, 35);
  const last = day0(new Date(end.getTime() - 1));
  if (last >= to) to = addDays(mondayOf(last), 7);
  const free = addDays(day0(now), 22);
  // (server bere nejvýš ~400 dní — u data hluboko v minulosti se volno od dneška nehlídá)
  if (start < now && free > to && free - from <= 380 * 86400000) to = free;
  if (to - from > 390 * 86400000) to = addDays(from, 390);   // dialog stejně hlídá nejvýš 62 dní rozsahu
  return { from: ymd(from), to: ymd(addDays(to, -1)) };
}
export const isMulti = (a) => !sameDay(a._s, new Date(a._e.getTime() - 1));
export const timeLabel = (a) => (a.timed ? (isMulti(a) ? `${a._s.getDate()}. ${hm(a._s)} → ${a._e.getDate()}. ${hm(a._e)}` : `${hm(a._s)}–${hm(a._e)}`)
  : isMulti(a) ? `${a._s.getDate()}. ${a._s.getMonth() + 1}. – ${new Date(a._e.getTime() - 1).getDate()}. ${new Date(a._e.getTime() - 1).getMonth() + 1}.` : "během dne");

// Nepřítomnost z Docházky pro člověka a den (víkend se nepočítá).
export function absenceOn(absences, uid, d) {
  if (dow(d) > 4) return null;
  const k = ymd(d);
  return absences.find((x) => x.user_id === uid && x.date_from <= k && x.date_to >= k) || null;
}
export const isPartial = (rec) => rec.part === "time" || rec.part === "half";
export function absenceRange(rec, person) {
  const [w0, w1] = workOf(person);
  if (rec.part === "time" && rec.t_from && rec.t_to) return [toH(rec.t_from), toH(rec.t_to)];
  if (rec.part === "half") { const mid = (w0 + w1) / 2; return rec.half === "pm" ? [mid, w1] : [w0, mid]; }
  return [w0, w1];
}
export const absenceLabel = (rec) => (ABSENCE[rec.type]?.label || rec.type_label || "Nepřítomnost")
  + (rec.part === "time" && rec.t_from ? ` ${rec.t_from}–${rec.t_to}` : rec.part === "half" ? (rec.half === "pm" ? " odpoledne" : " dopoledne") : "")
  + (rec.status === "pending" ? " · čeká" : "");
export const absenceTone = (rec) => ABSENCE[rec.type]?.tone || "off";

export const overlappingTimed = (items, ids, s, e, exclId) =>
  items.filter((a) => a.id !== exclId && a.inGrid && isOpenTask(a) && a.assignees.some((id) => ids.includes(id)) && a._s < e && a._e > s);
export const tasksOnDay = (items, uid, d, exclId) =>
  items.filter((a) => a.id !== exclId && a.status !== "Schváleno" && a.assignees.includes(uid) && spansDay(a, d)).length;

// Dostupnost člověka pro nový úkol: 0 volný · 1 mimo pracovní dobu / má úkoly · 2 obsazený · 3 nepřítomen.
export function availability(person, items, absences, s, e, { timed, exclId } = {}) {
  const rec = absenceOn(absences, person.id, s);
  if (rec) {
    const [f, t] = absenceRange(rec, person);
    if (!timed || (hourOf(s) < t && hourOf(e) > f)) return { rank: 3, label: absenceLabel(rec).toLowerCase(), tone: absenceTone(rec) };
  }
  if (timed) {
    if (overlappingTimed(items, [person.id], s, e, exclId).length) return { rank: 2, label: "obsazený", tone: "busy" };
    const [w0, w1] = workOf(person);
    if (sameDay(s, new Date(e.getTime() - 1)) && (hourOf(s) < w0 || hourOf(e) > w1 || dow(s) > 4)) return { rank: 1, label: "mimo pracovní dobu", tone: "muted" };
    return { rank: 0, label: "volný", tone: "free" };
  }
  const n = tasksOnDay(items, person.id, s, exclId);
  if (n) return { rank: 1, label: `už má ${n} ${tasksWord(n)}`, tone: "muted" };
  return { rank: 0, label: "volný", tone: "free" };
}

// Nejbližší čas (po 30 min, pracovní dny, 21 dní), kdy jsou VŠICHNI volní ve společné pracovní době.
export function findFree({ items, absences, people, start, durMin, exclId, now = new Date() }) {
  if (!people.length) return null;
  const w0 = Math.max(...people.map((p) => workOf(p)[0])), w1 = Math.min(...people.map((p) => workOf(p)[1]));
  const dur = Math.min(durMin, (w1 - w0) * 60);
  let d = day0(start < now ? now : start);
  for (let k = 0; k < 21; k++, d = addDays(d, 1)) {
    if (dow(d) > 4 || people.some((p) => { const r = absenceOn(absences, p.id, d); return r && !isPartial(r); })) continue;
    let t0 = Math.max(w0, sameDay(d, start) ? hourOf(start) : w0);
    if (sameDay(d, now)) t0 = Math.max(t0, Math.ceil(hourOf(now) * 2) / 2);
    for (let t = Math.ceil(t0 * 2) / 2; t + dur / 60 <= w1; t += 0.5) {
      const s = atHour(d, t), e = new Date(s.getTime() + dur * 60000);
      if (people.every((p) => availability(p, items, absences, s, e, { timed: true, exclId }).rank === 0)) return s;
    }
  }
  return null;
}

// Bloky vedle sebe, když se v jednom dni překrývají.
export function layoutLanes(list) {
  const sorted = [...list].sort((x, y) => x._s - y._s);
  const ends = []; const lane = {};
  sorted.forEach((a) => { let i = ends.findIndex((e) => e <= a._s); if (i < 0) { i = ends.length; ends.push(a._e); } else ends[i] = a._e; lane[a.id] = i; });
  return { lane, lanes: Math.max(1, ends.length) };
}
export function clipToDay(a, d) {
  const from = sameDay(a._s, d) ? Math.max(GRID_START, hourOf(a._s)) : GRID_START;
  const to = sameDay(a._e, d) ? Math.min(GRID_END, hourOf(a._e)) : GRID_END;
  return [from, Math.max(from + 0.25, to)];
}

// Přesun úkolu v kalendáři → PATCH tělo (zachová délku i čas).
export function moveBody(item, toDay, hour) {
  const days = Math.round((day0(toDay) - day0(item._s)) / 86400000);
  const dl = ymd(addDays(parseLocal(`${(item.deadline || "").slice(0, 10)}T00:00`), days));
  const body = { deadline: dl };
  if (item.start_date) body.start_date = ymd(addDays(parseLocal(`${item.start_date.slice(0, 10)}T00:00`), days));
  if (hour != null && item.inGrid) {
    const dur = (item._e - item._s) / 3600000;
    const h = Math.max(6, Math.min(22 - dur, Math.round(hour * 4) / 4));
    body.time_from = hhmm(h); body.time_to = hhmm(h + dur);
  }
  return body;
}
